<template>
    <v-data-table
            :headers="headers"
            :items="items"
            :server-items-length="total"
            :loading="loading"
            loading-text="Loading... Please wait"
            :options.sync="pagination"
            class="elevation-3"
            :footer-props="{
               itemsPerPageOptions: [10, 25, 50, 100, {text: 'Всі', value: -1}]
            }"
    >
        <template v-slot:item.professor="{item}">
            {{item.professor.surname}} {{item.professor.name}} {{item.professor.patronymic}}
        </template>
        
        <template v-slot:item.actions="{item}">
<!--            <v-btn icon class="mx-0" @click="$emit('editItem', item.id)">-->
<!--                <v-icon color="primary">edit</v-icon>-->
<!--            </v-btn>-->
            <v-btn icon class="mx-0" @click="$emit('deleteItem', item.id)">
                <v-icon color="red">delete</v-icon>
            </v-btn>
        </template>
    </v-data-table>
</template>
<script>
    import {formatShortDate} from "../../../../helpers/dateHelper";

    export default {
        props: {
            items: {
                type: Array,
            },
            total: {
                type: Number,
            },
            loading: {
                type: Boolean,
            },
        },
        watch: {
            pagination(paginationVal, prevPaginationVal) {
                this.$emit("paginate", paginationVal);
            }
        },
        data: () => ({
            pagination: {
                totalItems: 0,
            },
            headers: [
                {text: 'Викладач', value: 'professor'},
                {text: 'Дії', value: 'actions', sortable: false}
            ],
            formatShortDate,
        }),
    }
</script>